import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

const PurchaseOrderField = () => {
  const { t } = useTranslation();
  const { register } = useFormContext();

  return (
    <div className="w-full sm:w-1/2">
      <label className="label-input p3-semibold" htmlFor="purchaseOrderNumber">
        {t('registrationPage.po')}
      </label>
      <input
        className="standard-input w-full"
        type="text"
        {...register('purchaseOrderNumber')}
      />
    </div>
  );
};

export default PurchaseOrderField;
